export default {
  // 基础url前缀
  // baseURL: '/cnewec/pwxweb/',生产
  baseURL: '/pwxweb/',// 测试
  // `headers` 是即将被发送的自定义请求头
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type':'application/json'
  },
  // 设置超时时间
  timeout: 60000,
  // `withCredentials` 表示跨域请求时是否需要使用凭证
  withCredentials: false, // 默认值
  // `responseType` 表示服务器响应的数据类型，可以是 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'
  responseType: 'json', // 默认值
}



// WEBPACK FOOTER //
// ./src/plugins/axios/config.js